"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Hash = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "16", height: "16", viewBox: "0 0 16 16", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("path", { d: "M3.12801 3.85083H15.8885L15.2751 6.05285H2.51465L3.12801 3.85083Z", fill: "#8790A6" }),
    /* @__PURE__ */ React.createElement("path", { d: "M1.50203 9.71313H14.2403L13.627 11.9152H0.888672L1.50203 9.71313Z", fill: "#8790A6" }),
    /* @__PURE__ */ React.createElement("path", { d: "M6.34621 0.382812L2.14746 15.3806L4.35177 15.3817L8.55052 0.383889L6.34621 0.382812Z", fill: "#8790A6" }),
    /* @__PURE__ */ React.createElement("path", { d: "M12.4273 0.383667L8.22852 15.3815L10.4328 15.3825L14.6316 0.384742L12.4273 0.383667Z", fill: "#8790A6" })
  );
};
export default Hash;
